import React, { useEffect, useState } from 'react'
import { getCookieItem, CookieKeyTypeEnum } from '../../util/cookie-domain'
import { Campaign } from '../../util/enums/Campaign'
import { useGlobalContext } from 'src/contexto/contextoGlobal'

type LiveloBadgeTextProps = {
  price: number
}

export const LiveloBadgeText = ({ price }: LiveloBadgeTextProps) => {
  const [liveloText, setLiveloText] = useState('')
  const isComingFromLivelo =
    getCookieItem(CookieKeyTypeEnum.campaign) === Campaign.LIVELO

  const { reward } = useGlobalContext()

  useEffect(() => {
    if (isComingFromLivelo && reward) {
      const calculatedPoints = Math.round(
        (price / reward.value) * reward.points
      )
      setLiveloText(`${calculatedPoints.toLocaleString('pt-BR')} Pontos`)
    }
  }, [isComingFromLivelo, price, reward])

  return <>{liveloText}</>
}
